import { Component, OnInit } from '@angular/core';
import { WorkerSeizuresAmmountsService } from '../../_services/workers-seizures-ammounts.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { WorkerSeizureAmmount } from '../../_types/worker-seizure-ammount';
import { firstValueFrom } from 'rxjs';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-workers-seizure-ammount',
    templateUrl: './workers-seizure-ammount.component.html',
    styleUrls: ['./workers-seizure-ammount.component.css'],
    standalone: false
})
export class WorkersSeizureAmmountComponent implements OnInit {


    public workerSeizureAmmountFormGroup!: RxFormGroup;
    public workerSeizureAmmount: WorkerSeizureAmmount = new WorkerSeizureAmmount();  
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private workersSeizuresAmmountsService: WorkerSeizuresAmmountsService,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
        private config: DynamicDialogConfig
  ) {
    this.workerSeizureAmmountFormGroup = this.formBuilder.formGroup<WorkerSeizureAmmount>(this.workerSeizureAmmount) as RxFormGroup;
   }

  ngOnInit() {

    console.log(this.config.data);
    
    if (this.config.data.id) {
      this.loadworkerSeizureAmmount(this.config.data.id);
    } else {
      this.workerSeizureAmmount.workerSeizureId = this.config.data.workerSeizureId;     
      console.log(this.workerSeizureAmmount);
    this.workerSeizureAmmountFormGroup.patchValue(this.workerSeizureAmmount);
    }

    this.allowWrite = this.loginService.hasPermission("WORKERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS.DELETE");
  }

  async loadworkerSeizureAmmount(id: string){
    this.workerSeizureAmmount = await firstValueFrom(this.workersSeizuresAmmountsService.get(id));
    console.log(this.workerSeizureAmmount);

    this.workerSeizureAmmountFormGroup.patchValue(this.workerSeizureAmmount);
  }

  async save() {    
    let valid = this.formValidationService.validateForm(this.workerSeizureAmmountFormGroup);    
    if (valid) {
      this.workerSeizureAmmount = Object.assign(this.workerSeizureAmmount, this.workerSeizureAmmountFormGroup.value);
      
      console.log(this.workerSeizureAmmount);


      let workerSeizure = await firstValueFrom(this.workersSeizuresAmmountsService.save(this.workerSeizureAmmount));   

      this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Embargo asignado correctamente' });
      this.dynamicDialogRef.close();
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el valor del embargo?",
      header: "Eliminar embargo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workersSeizuresAmmountsService.delete(this.workerSeizureAmmount.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Embargo eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

}
